import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';

export default function NotFound() {
  return (
    <>
      <SEOHead title="页面未找到 - 妖精漫画" description="抱歉，您访问的页面不存在。" />
      <Navbar />
      <main className="pt-16 min-h-[80vh] flex items-center justify-center px-4">
        <div className="text-center">
          <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-background-100 flex items-center justify-center">
            <i className="ri-emotion-sad-line text-4xl text-foreground-300"></i>
          </div>
          <h1 className="text-3xl font-heading font-bold text-foreground-900 mb-2">404</h1>
          <p className="text-lg text-foreground-600 mb-2">页面未找到</p>
          <p className="text-sm text-foreground-400 mb-8">抱歉，您访问的页面不存在或已被移除。</p>
          <div className="flex items-center justify-center gap-3">
            <Link to="/" className="px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">
              返回首页
            </Link>
            <Link to="/category/all" className="px-5 py-2.5 bg-background-100 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap">
              浏览漫画
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}